import apiClient from "../clients/apiClient";
import { safeRequest } from "../safeRequest";

export const DashboardService = {
  async getAdminDashboard() {
    return safeRequest(
      apiClient.get("/dashboard/admin").then((response) => response.data),
    );
  },
};
